import { Box, Chip, MenuItem, TableCell } from '@mui/material'
import { Select } from 'mui-rff'
import { memo } from 'react'
import { Form, FormSpy } from 'react-final-form'
import { WbAutocomplete } from 'src/components/WbAutocomplete'
import { MasterWorkoutLookups, MasterWorkoutMax } from 'src/types/MasterWorkout'

interface MasterWorkoutMaxFormProps {
	initialValues: MasterWorkoutMax
    lookups: MasterWorkoutLookups
	onSubmit: (value: any) => void
}

const MasterWorkoutMaxForm: React.FC<MasterWorkoutMaxFormProps> = ({ initialValues, lookups, onSubmit }) => {
	const { masterExercises, groupTerms } = lookups
	const formFields = [
		{
			field: (
				<FormSpy subscription={{ values: true }}>
					{({ values }) => {
						const items =
							values?.groupTermIds?.length > 0 ? masterExercises.filter((x) => values?.groupTermIds?.includes(x.masterExerciseGroupMainId)) : masterExercises

						return (
							<WbAutocomplete
								name="masterExerciseId"
								label="Master Exercise"
								options={items}
								getOptionValue={(x) => {
									return x.value
								}}
								getOptionLabel={(x: any) => {
									return x.name
								}}
								renderOption={(props, option) => {
									return (
										<li {...props} key={option.value}>
											{option.name}
										</li>
									)
								}}
							/>
						)
					}}
				</FormSpy>
			),
		},
		{
			field: (
				<WbAutocomplete
					name="groupTermIds"
					label="Choose exercise category"
					multiple
					options={groupTerms}
					getOptionValue={(x) => {
						return x.value
					}}
					getOptionLabel={(x: any) => {
						return x.name
					}}
					renderOption={(props, option) => {
						return (
							<li {...props} key={option.value}>
								{option.name}
							</li>
						)
					}}
					renderTags={(values, getTagProps) =>
						values.map((value, index: number) => {
							console.log(value)
							return <Chip key="index" variant="outlined" label={value?.name} {...getTagProps({ index })} />
						})
					}
				/>
			),
		},
	]

	return (
		<Form
			onSubmit={onSubmit}
			initialValues={initialValues}
			render={() => {
				return (
					<>
						<FormSpy onChange={({ values, dirty }) => dirty && onSubmit(values)} subscription={{ values: true, dirty: true }} />
						{formFields.map((item, idx) => (
							<TableCell key={idx}>{item.field}</TableCell>
						))}
					</>
				)
			}}
		/>
	)
}

export default memo(MasterWorkoutMaxForm)
